document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("promo-popup-overlay");
  if (!overlay) return;

  const closeBtn = overlay.querySelector(".promo-popup-close");

  /* -------------------------------------------
      SHOW ONLY ONCE PER SESSION
  --------------------------------------------*/
  function alreadyShown() {
    return sessionStorage.getItem("promoPopupShown") === "1";
  }

  function markShown() {
    sessionStorage.setItem("promoPopupShown", "1");
  }

  function showPopup() {
    // NEW: If already shown this session → do nothing
    if (alreadyShown()) {
      console.log("[promo-popup] Already shown this session.");
      return;
    }

    overlay.style.display = "flex";
    markShown();

    const countdownEnabled = overlay.dataset.countdown === "true";
    const useSchedule = overlay.dataset.useSchedule === "true";
    const endDate = overlay.dataset.end;
    const countdownContainer = overlay.querySelector("[data-countdown-container]");

    if (countdownEnabled && useSchedule && countdownContainer) {
        startPromoCountdown(endDate, countdownContainer);
    }
  }
  
  function hidePopup() {
    overlay.style.display = "none";
  }

  // Close actions
  closeBtn.addEventListener("click", hidePopup);
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) hidePopup();
  });

  // Trigger on AJAX Add to Cart
  document.addEventListener("variant:add", function () {
    console.log("[promo-popup] Triggered by variant:add");
    showPopup();
  });
});

/* -----------------------------------------------------------
   COUNTDOWN
----------------------------------------------------------- */
function startPromoCountdown(endTime, container) {
  function updateCountdown() {
    const now = new Date().getTime();
    const end = new Date(endTime).getTime();
    const distance = end - now;

    if (distance <= 0) {
      container.textContent = "Offer expired";
      clearInterval(interval);
      return;
    }

    const hours = Math.floor((distance / (1000 * 60 * 60)));
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);

    container.textContent = `${hours}h ${minutes}m ${seconds}s`;
  }

  updateCountdown();
  const interval = setInterval(updateCountdown, 1000);
}
/* -----------------------------------------------------------
   CART DRAWER COUNTDOWN
----------------------------------------------------------- */
(function () {
  const drawer = document.querySelector("#promo-cart-drawer");
  if (!drawer) return;

  const end = drawer.dataset.end;
  const countdownContainer = drawer.querySelector("[data-countdown-container]");
  const useCountdown = drawer.dataset.countdown === "true";

  if (!useCountdown || !countdownContainer) return;

  function updateDrawerCountdown() {
    const endDate = new Date(end.replace(" ", "T"));
    const now = new Date();
    const diff = endDate - now;

    if (diff <= 0) {
      countdownContainer.textContent = "Expired";
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    countdownContainer.textContent = `${hours}h ${minutes}m ${seconds}s`;
  }

  updateDrawerCountdown();
  setInterval(updateDrawerCountdown, 1000);
})();
/* -----------------------------------------------------------
   COUNTDOWN – CART DRAWER
----------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const drawerMsg = document.querySelector(".promo-cart-drawer-message");
  if (!drawerMsg) return;

  const countdownEnabled = drawerMsg.dataset.countdown === "true";
  const endDate = drawerMsg.dataset.end;
  const countdownBox = drawerMsg.querySelector(".promo-cart-drawer-countdown");

  if (!countdownEnabled || !endDate || !countdownBox) return;

  function updateDrawerCountdown() {
    const now = new Date().getTime();
    const end = new Date(endDate).getTime();
    const diff = end - now;

    if (diff <= 0) {
      countdownBox.textContent = "Offer expired";
      clearInterval(timer);
      return;
    }

    const h = Math.floor(diff / 36e5);
    const m = Math.floor((diff % 36e5) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    countdownBox.textContent = `${h}h ${m}m ${s}s`;
  }

  updateDrawerCountdown();
  const timer = setInterval(updateDrawerCountdown, 1000);
});
/* CART PAGE COUNTDOWN ---------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  const cartMsg = document.querySelector(".promo-cart-page-message");
  if (!cartMsg) return;

  const countdownEnabled = cartMsg.dataset.countdown === "true";
  if (!countdownEnabled) return;

  const endDate = cartMsg.dataset.end;
  const container = cartMsg.querySelector(".promo-cart-page-countdown");

  if (endDate && container) {
    startPromoCountdown(endDate, container);
  }
});
